import { Injectable } from '@angular/core';
import { UrlHelper } from "../../classes/urlHelper";
import { HttpClient, HttpHeaders } from '@angular/common/http';

const headers = new HttpHeaders({ 'responseType': 'arraybuffer' });

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private httpClient: HttpClient) { }

  getAsinPerformanceReport(query) {
    return this.httpClient.get<any>('api/report/getAsinPerformanceReport/' + new UrlHelper().parseToUrlParams(query, 'query.'));
  }

  exportAsinReport(query) {
    return this.httpClient.get('api/report/exportAsinPerformanceReport/' + new UrlHelper().parseToUrlParams(query, 'query.'),
      { responseType: 'arraybuffer', headers: headers }
    );
  }

  genMerchantNetworthReport(query) {
    return this.httpClient.get<any>('api/report/getMerchantNetworthReport/' + new UrlHelper().parseToUrlParams(query, 'query.'));

  }
}
